import { LayoutComponent } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 2,
        rows: 2,
        colsSize: [1, 2],
        rowsSize: [0, 0],
        rowSpan: {
          "0:0": 2,
        },
        gap: "10px",
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data:
                      "In order to achieve an instrumental evaluation methodology that can be used to predict the perceived Sound Quality of future measurements, so-called Sound Quality Metrics are developed. Within the process of Sound Quality Metric Development, regression models are calculated to correlate the identified set of (psycho-)acoustic analysis methods to the jury test ratings. Sound Quality Metrics are defined by correlating the selected (psycho-)acoustic analysis methods to the jury test ratings. The achieved metrics evaluate the perceived sound quality instrumentally by calculating sound quality single values for the investigated sounds.",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
                styles: {
                  width: "93%",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/02/case01/slide05-correlation-image.svg`,
                    styles: {
                      height: "450px",
                    },
                  },
                },
              },
            },
          ],
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    scrollbars: false,
                    data: "SQ  = 18.254 - 0.12365 * Loudness  - 3.4106 * Sharpness + 6.0734 * Tonality",
                    styles: {
                      fontSize: "12px",
                      fontWeight: 600,
                    },
                  },
                },
              },
            },
          ],
        ],
      },
      styles: {
        borderBottom: `solid 1px ${variables["default-light"]}`,
      },
    },
  },
];

export default components;
